module.exports = {"batches":{"name":"الفترات","desc":"الفترات التى سجلها الطلبة"},"results":{"name":"نتائج الفترة الدراسية","courseCode":"كود المادة","courseName":"إسم المادة","attendance":"الحضور","seven":" الإسبوع <br/>  <span class='hidden-xs'>  السابع (30%)","twelve":" الإسبوع <br/>  <span class='hidden-xs'>  الإثني عشر (20%)","work":" أعمال  <br/>  <span class='hidden-xs'>  الفصلية (10%)","final":"التقدير"},"achievement":{"desc":"إنجاز الفترة الدراسية","term":"إنجاز الفترة الدراسية","total":"الإنجاز الكلي","credit":"الساعات المنجزة","gpa":"المعدل التراكمي"}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/results/Lang/ar.json
// module id = 71
// module chunks = 0